/* tslint:disable */
/* eslint-disable */
/**
 * MWS.CatalogService.WebApp | v2-admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AddCategoriesToProductListingsRequest {
    'productListingIds': Array<string>;
    'categoryIds': Array<string>;
}
export interface AdminAthleteData {
    'name': string;
    'shirtNumber': number | null;
    'position': string | null;
    'countryOfBirth': string | null;
    'dateOfBirth': string | null;
    'teamName': string | null;
    'shirtSize': string | null;
    'placeOfBirth': string | null;
    'nationality': string | null;
}
export interface AdminAthleteDataRequest {
    'name': string | null;
    'shirtNumber': number | null;
    'position': string | null;
    'countryOfBirth': string | null;
    'dateOfBirth': string | null;
    'teamName': string | null;
    'shirtSize': string | null;
}
export interface AdminAthleteDetails {
    'number': string | null;
    'footballDetails': AdminFootballDetails | null;
}
export interface AdminAthleteFixtureDetails {
    'athleteFixtureDetailsId': string;
    'sportsAthleteId': string | null;
    'sportsFixtureId': string | null;
    'name': string | null;
    'countryOfBirth': string | null;
    'cityOfBirth': string | null;
    'dateOfBirth': string | null;
    'teamName': string | null;
    'bio': string | null;
    'athleteDetails': AdminAthleteDetails | null;
    'externalAthleteId': string | null;
    'externalFixtureId': string | null;
    'externalTeamId': string | null;
    'externalSeasonId': string | null;
    'externalLeagueId': string | null;
    'seasonName': string | null;
    'leagueName': string | null;
}
export interface AdminBidder {
    'id': string;
    'userId': string;
    'bidLimit': number;
    'bidBlocked': boolean;
    'emailVerified': boolean;
    'phoneNumberVerified': boolean;
    'addressVerified': boolean;
    'paymentVerified': boolean;
    'idVerified': boolean;
}
export interface AdminClaim {
    'id': string;
    'userId': string;
    'productId': string;
    'productName': string | null;
    'dateCreated': Date;
    'isDeleted': boolean;
    'userFirstName': string | null;
    'userLastName': string | null;
}
export interface AdminClaimList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminClaim>;
}
export interface AdminFixtureData {
    'matchName': string;
    'finalScore': string | null;
    'venue': string | null;
    'date': string | null;
    'season': string | null;
    'league': string | null;
    'homeTeamName': string | null;
    'awayTeamName': string | null;
}
export interface AdminFixtureDataRequest {
    'matchName': string | null;
    'finalScore': string | null;
    'venue': string | null;
    'date': string | null;
    'season': string | null;
    'league': string | null;
}
export interface AdminFixtureDetails {
    'fixtureDetailsId': string;
    'fixtureDate': Date | null;
    'venueName': string | null;
    'seasonName': string | null;
    'matchName': string | null;
    'leagueName': string | null;
    'sportsFixtureId': string | null;
    'sportsDetails': AdminSportsFixtureDetails | null;
    'region': string | null;
    'venueCity': string | null;
}
export interface AdminFootballDetails {
    'position': FootballPositionType | null;
}


export interface AdminLinkedFrame {
    'displayName': string | null;
    'id': string;
    'serial': string | null;
    'dateCreated': Date;
}
export interface AdminListing {
    'id': string;
    'productId': string;
    'eventId': string | null;
    'displayName': string | null;
    'slug': string;
    'salesMethod': SalesMethod;
    'visibility': SkuVisibility;
    'startDate': Date;
    'endDate': Date;
    'isWon': boolean | null;
    'price': { [key: string]: number; };
    'priceInEuroCents': number;
    'financialDetails': ListingFinancialDetails;
    'eventScheduleContractId': string | null;
    'priorityScore': number | null;
    'product': AdminProductDetails;
}


export interface AdminMaxBid {
    'id': string;
    'dateCreated': Date;
    'priceInCentsInCurrency': number;
    'platformId': string;
    'currencyCode': string;
    'isActive': boolean;
    'eventId': string | null;
    'eventName': string | null;
    'productListingId': string;
    'productListingDisplayName': string | null;
    'priceInCentsInEuro': number | null;
    'userEmailAddress': string | null;
    'userId': string;
}
export interface AdminMaxBidList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminMaxBid>;
}
export interface AdminMediaContent {
    'type': string;
    'url': string;
    'visibility': boolean;
    'adminMetaData': AdminMetaData;
}
export interface AdminMediaContentRequest {
    'type': MediaType;
    'url': string;
    'visibility': boolean;
    'metaData': AdminMetaDataRequest;
}


export interface AdminMetaData {
    'applyPadding': boolean;
    'origin': ImageOrigin;
    'createdAt': Date;
    'createdBy': string | null;
    'fromPhotoStudio': string | null;
    'photoStudioSetting': string | null;
}


export interface AdminMetaDataRequest {
    'applyPadding': boolean;
    'origin': ImageOrigin;
}


export interface AdminProduct {
    'dateCreated': Date;
    'details': { [key: string]: string; } | null;
    'id': string;
    'athleteId': string | null;
    'framedProductId': string | null;
    'teamId': string | null;
    'signatureStandard': SignatureStandard;
    'hasListing': boolean;
    'isLinkedToFrame': boolean;
    'stock': number;
    'labels': Array<Label>;
    'trackableProductId': string | null;
    'inventoryLocation': string | null;
    'displayName': string | null;
    'serial': string | null;
    'athleteName': string | null;
    'teamName': string | null;
}


export interface AdminProductDetails {
    'dateCreated': Date;
    'dateModified': Date;
    'athleteId': string;
    'createdBy': string;
    'frameMockupSetId': string;
    'id': string;
    'modifiedBy': string;
    'productTypeId': string;
    'shippingOfficeId': string;
    'currentListingId': string | null;
    'fabricksTrackableProductId': string | null;
    'framedProductId': string | null;
    'supplierVendorId': string | null;
    'teamId': string | null;
    'details': { [key: string]: string; } | null;
    'media': Array<AdminMediaContent>;
    'categories': Array<Category>;
    'labels': Array<Label>;
    'location': InventoryLocation;
    'authenticityMethod': AuthenticityMethod;
    'inboundStatus': ProductInventoryInboundStatus;
    'receivedStatus': ProductReceivedStatus;
    'serialType': ProductSerialType;
    'shippingType': ShippingType;
    'tierType': TierType;
    'signatureStandard': SignatureStandard;
    'customizable': boolean;
    'isFrame': boolean;
    'isLinkedToFrames': boolean;
    'stock': number | null;
    'certificateNumber': string;
    'serialNumber': string;
    'odooFrameSerialNumber': string | null;
    'odooStockLotUrl': string | null;
    'countryOfOrigin': string | null;
    'description': string | null;
    'internalName': string | null;
    'name': string | null;
    'teamLogo': string | null;
    'type': string | null;
    'shippingDescription': string | null;
    'image360Url': string | null;
    'functionalDescription': string | null;
    'specialTierInformation': SpecialTierInformation | null;
    'athleteData': AdminAthleteData | null;
    'fixtureData': AdminFixtureData | null;
}


export interface AdminProductList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminProduct>;
}
export interface AdminSportsFixtureDetails {
    'homeTeam': FixtureDetailsTeam | null;
    'awayTeam': FixtureDetailsTeam | null;
    'football': FootballFixtureDetails | null;
    'basketball': BasketballFixtureDetails | null;
}

export enum AuthenticityMethod {
    CertificateNumber = 'certificate_number',
    Fabricks = 'fabricks',
    None = 'none'
}


export interface BasketballFixtureDetails {
    'score': string | null;
}
export interface BulkUpdateProductMediaUrlsRequest {
    'productMedias': Array<MediasPerProduct>;
}
export interface Category {
    'id': string;
    'canonicalName': string;
    'slug': string;
    'externalReference': ExternalReference | null;
    'logoUrl': string | null;
    'bannerUrl': string | null;
    'defaultEventBannerUrl': string | null;
    'cutoutImageUrl': string | null;
    'mobileCutoutImageUrl': string | null;
    'primaryColor': string | null;
    'secondaryColor': string | null;
    'showUpcomingEvents': boolean;
    'showAsCardView': boolean;
    'showTotalRaised': boolean;
    'priorityScore': number;
    'description': string | null;
    'sendNotifications': boolean;
    'nameTranslation': Translation | null;
    'liveEventCount': number | null;
    'upcomingEventCount': number | null;
    'historicalEventCount': number | null;
    'name': string;
    'relatedCategories': Array<RelatedCategory> | null;
}

export enum CategoryType {
    Country = 'country',
    League = 'league',
    Team = 'team',
    Sport = 'sport',
    Other = 'other',
    Gender = 'gender',
    Athlete = 'athlete',
    Condition = 'condition',
    Highlight = 'highlight',
    Campaign = 'campaign'
}


export interface CreateNewProductRequest {
    'productTypeId': string;
    'shippingOfficeId': string;
    'athleteId': string | null;
    'frameMockupSetId': string | null;
    'supplierVendorId': string | null;
    'teamId': string | null;
    'authenticityMethod': AuthenticityMethod;
    'inventoryInboundStatus': ProductInventoryInboundStatus;
    'inventoryReceivedStatus': ProductReceivedStatus;
    'serialType': ProductSerialType;
    'shippingType': ShippingType;
    'stock': number | null;
    'displayName': string | null;
}


export interface CreateOrUpdateAthleteDetailsRequest {
    'number': string | null;
    'updateFootballDetailsRequest': CreateOrUpdateFootballDetailsRequest | null;
}
export interface CreateOrUpdateAthleteFixtureDetailsRequest {
    'name': string | null;
    'countryOfBirth': string | null;
    'cityOfBirth': string | null;
    'dateOfBirth': string | null;
    'teamName': string | null;
    'bio': string | null;
    'updateAthleteDetailsRequest': CreateOrUpdateAthleteDetailsRequest | null;
}
export interface CreateOrUpdateBasketballFixtureDetailsRequest {
    'score': string | null;
}
export interface CreateOrUpdateFixtureDetailsRequest {
    'fixtureDate': Date | null;
    'venueName': string | null;
    'seasonName': string | null;
    'matchName': string | null;
    'leagueName': string | null;
    'sportsFixtureId': string | null;
    'sportsDetails': CreateOrUpdateSportsFixtureDetailsRequest | null;
    'region': string | null;
    'venueCity': string | null;
}
export interface CreateOrUpdateFixtureDetailsTeamRequest {
    'name': string | null;
    'logo': string | null;
}
export interface CreateOrUpdateFootballDetailsRequest {
    'position': string | null;
}
export interface CreateOrUpdateFootballFixtureDetailsRequest {
    'goals': Array<FixtureDetailsGoal> | null;
}
export interface CreateOrUpdateSportsFixtureDetailsRequest {
    'homeTeam': CreateOrUpdateFixtureDetailsTeamRequest | null;
    'awayTeam': CreateOrUpdateFixtureDetailsTeamRequest | null;
    'football': CreateOrUpdateFootballFixtureDetailsRequest | null;
    'basketball': CreateOrUpdateBasketballFixtureDetailsRequest | null;
}
export interface DeleteOutboxMessages {
    'deletedCount': number;
}
export interface DeleteOutboxMessagesRequest {
    'ids': Array<string>;
}
export interface ErrorFailuresInner {
    'errorCode': string;
    'errorMessage': string;
    'propertyName': string;
}
export interface EventMockup {
    'eventName': string;
    'eventId': string;
    'startDate': Date;
    'featureTeamName': string | null;
    'kitName': string;
    'kitId': string;
    'rosterId': string | null;
    'pendingApprovalMockupsCount': number;
    'incompleteMockupsCount': number;
    'kitImageUrl': string | null;
    'teamId': string;
}
export interface EventMockupList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<EventMockup>;
}

export enum EventMockupsStatus {
    Complete = 'complete',
    Incomplete = 'incomplete',
    Pending = 'pending'
}


export interface ExternalReference {
    'externalId': string | null;
    'type': CategoryType;
}



export enum FixtureDetailGoalType {
    Goal = 'goal',
    OwnGoal = 'own_goal',
    Penalty = 'penalty'
}


export interface FixtureDetailsGoal {
    'isHomeTeamGoal': boolean;
    'scorerName': string;
    'minute': number;
    'goalType': FixtureDetailGoalType;
    'extraMinute': number | null;
}


export interface FixtureDetailsTeam {
    'name': string | null;
    'logo': string | null;
}
export interface FootballFixtureDetails {
    'goals': Array<FixtureDetailsGoal> | null;
    'score': string | null;
}

export enum FootballPositionType {
    Goalkeeper = 'goalkeeper',
    Defender = 'defender',
    Midfielder = 'midfielder',
    Attacker = 'attacker'
}



export enum FramingType {
    NotFrameable = 'not_frameable',
    Frameable = 'frameable',
    Framed = 'framed'
}


export interface GenerateAiProductsDescriptionsRequest {
    'productIds': Array<string>;
    'extraInformation': string | null;
}

export enum ImageOrigin {
    Mockup = 'mockup',
    Photo = 'photo',
    Unknown = 'unknown',
    Filler = 'filler',
    Gallery = 'gallery'
}


export interface InventoryLocation {
    'type': InventoryLocationType;
    'section': number | null;
    'subSection': string | null;
    'abbreviation': string | null;
    'locationString': string;
}



export enum InventoryLocationType {
    Unknown = 'unknown',
    Processing = 'processing',
    Short = 'short',
    Special = 'special',
    Shipping = 'shipping',
    Long = 'long',
    Framing = 'framing',
    Shipped = 'shipped',
    ToLong = 'to_long',
    Odoo = 'odoo',
    Box = 'box',
    Rack = 'rack'
}


export interface Label {
    'id': string;
    'text': string;
    'description': string;
}
/**
 * Response model for listing financial details.
 */
export interface ListingFinancialDetails {
    'partnerId': string;
    'partnerName': string | null;
    'contractId': string | null;
    'beneficiaryId': string | null;
    'settingsId': string | null;
}

export enum MediaType {
    Video = 'video',
    Image = 'image'
}


export interface MediasPerProduct {
    'productId': string;
    'mediaContentUrls': Array<string>;
    'origin': string;
}
export interface ModelError {
    'code': string;
    'message': string;
    'failures': Array<ErrorFailuresInner> | null;
}
export interface MoveProductListingRequest {
    'eventId': string;
}
export interface OutboxFailedHandler {
    'name': string;
}
export interface OutboxMessage {
    'id': string;
    'type': string;
    'state': OutboxMessageState;
    'timestamp': Date;
    'dateCreated': Date;
    'retryCount': number;
    'traceId': string | null;
    'spanId': string | null;
    'userId': string | null;
    'platformId': string | null;
    'version': string;
    'failedHandlers': Array<OutboxFailedHandler>;
    'payload': any;
}


export interface OutboxMessageList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<OutboxMessage>;
}

export enum OutboxMessageState {
    Created = 'created',
    Published = 'published',
    Failed = 'failed'
}


export interface ProductAiDescriptionRequest {
    'extraInformation': string;
}

export enum ProductInventoryInboundStatus {
    Expected = 'expected',
    Duplicate = 'duplicate',
    Cancelled = 'cancelled',
    Extra = 'extra',
    Upgraded = 'upgraded'
}


export interface ProductPickListItem {
    'productId': string | null;
    'productListingId': string | null;
    'productName': string;
    'location': string;
    'eventName': string | null;
    'eventFeaturedTeamName': string | null;
}
export interface ProductPickListItemList {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ProductPickListItem>;
}

export enum ProductReceivedStatus {
    Received = 'received',
    NotReceived = 'not_received',
    NotApplicable = 'not_applicable',
    Unknown = 'unknown'
}



export enum ProductSerialType {
    Serial = 'serial',
    Lot = 'lot'
}


export interface RelatedCategory {
    'id': string;
    'name': string;
    'slug': string;
    'externalReference': ExternalReference | null;
    'logoUrl': string | null;
}
export interface ResetOutboxMessages {
    'updatedCount': number;
}
export interface ResetOutboxMessagesRequest {
    'ids': Array<string>;
}
/**
 * External provider IDs used to resolve (GetOrCreate) the corresponding sports entities. All fields are optional – pass only the IDs that are known.
 */
export interface ResolveExternalSportsEntitiesRequest {
    'fixtureId': string | null;
    'seasonId': string | null;
    'leagueId': string | null;
    'teamId': string | null;
    'athleteId': string | null;
}

export enum SalesMethod {
    Sweepstakes = 'sweepstakes',
    Bidding = 'bidding',
    FixedPrice = 'fixed_price',
    Resale = 'resale',
    AddOn = 'add_on'
}


export interface ScanData {
    'productId': string;
    'productListingId': string | null;
    'orderId': string | null;
    'chipId': string | null;
}

export enum Severity {
    Error = 'error',
    Warning = 'warning',
    Info = 'info'
}



export enum ShippingType {
    PaidShipping = 'paid_shipping',
    FreeShipping = 'free_shipping',
    NoShipping = 'no_shipping',
    FreeDomesticShipping = 'free_domestic_shipping'
}



export enum SignatureStandard {
    NotApplicable = 'not_applicable',
    Golden = 'golden',
    Faulty = 'faulty',
    Missing = 'missing'
}



export enum SkuVisibility {
    Published = 'published',
    Unpublished = 'unpublished'
}



export enum SortDirection {
    Ascending = 'ascending',
    Descending = 'descending'
}



export enum SortEventMockupOn {
    StartDate = 'start_date',
    MockupCompletion = 'mockup_completion'
}



export enum SortProductOn {
    Name = 'name',
    Stock = 'stock',
    Team = 'team',
    Athlete = 'athlete',
    Creationdate = 'creationdate',
    Location = 'location'
}


export interface SpecialTierInformation {
    'specialTierTitle': string | null;
    'specialTierDescription': string | null;
}
export interface SwitchProductMediaRequest {
    'imageOriginToSwitchTo': ImageOrigin;
}



export enum TierType {
    Normal = 'normal',
    Gold = 'gold'
}


export interface TranslateProductTextsRequest {
    'keys': Array<string> | null;
}
export interface Translation {
    'value': string | null;
    'isAiGenerated': boolean;
}

export enum TranslationEntityType {
    Product = 'product',
    Category = 'category',
    Event = 'event'
}


export interface Translations {
    'entityId': string;
    'key': string;
    'values': { [key: string]: Translation; };
}
export interface UpdateInventoryLocationRequest {
    'location': InventoryLocationType;
    'section': number | null;
    'subSection': string | null;
}


export interface UpdateNewProductRequest {
    'productTypeId': string;
    'framedProductId': string | null;
    'shippingOfficeId': string | null;
    'supplierVendorId': string | null;
    'teamId': string | null;
    'details': { [key: string]: string; } | null;
    'labelIds': Array<string> | null;
    'authenticityMethod': AuthenticityMethod;
    'tierType': TierType;
    'inboundStatus': ProductInventoryInboundStatus;
    'receivedStatus': ProductReceivedStatus;
    'shippingType': ShippingType;
    'signatureStandard': SignatureStandard | null;
    'customizable': boolean;
    'stock': number | null;
    'certificateNumber': string | null;
    'description': string | null;
    'functionalDescription': string | null;
    'name': string | null;
    'teamLogo': string | null;
    'shippingDescription': string | null;
    'odooFrameSerialNumber': string | null;
    'athleteData': AdminAthleteDataRequest | null;
    'fixtureData': AdminFixtureDataRequest | null;
    'specialTierTitle': string | null;
    'specialTierDescription': string | null;
}


export interface UpdateProductListingRequest {
    'slug': string;
    'startDate': Date;
    'endDate': Date;
    'priceInEuroCents': number;
    'productId': string;
    'beneficiaryId': string | null;
    'priority': number | null;
    'displayName': string | null;
}
export interface UpdateProductMediaUrlsRequest {
    'mediaContentUrls': Array<string>;
    'origin': string;
}
export interface UpdateTranslationRequest {
    'key': string;
    'language': string;
    'value': string;
    'isAiGenerated': boolean;
}
export interface ValidationFailure {
    'propertyName': string | null;
    'errorMessage': string | null;
    'attemptedValue': any;
    'customState': any;
    'severity': Severity;
    'errorCode': string | null;
    'formattedMessagePlaceholderValues': object | null;
}



/**
 * AdminAthleteFixtureDetailsApi - axios parameter creator
 */
export const AdminAthleteFixtureDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} athleteFixtureDetailsId 
         * @param {CreateOrUpdateAthleteFixtureDetailsRequest} createOrUpdateAthleteFixtureDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut: async (athleteFixtureDetailsId: string, createOrUpdateAthleteFixtureDetailsRequest: CreateOrUpdateAthleteFixtureDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'athleteFixtureDetailsId' is not null or undefined
            assertParamExists('v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut', 'athleteFixtureDetailsId', athleteFixtureDetailsId)
            // verify required parameter 'createOrUpdateAthleteFixtureDetailsRequest' is not null or undefined
            assertParamExists('v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut', 'createOrUpdateAthleteFixtureDetailsRequest', createOrUpdateAthleteFixtureDetailsRequest)
            const localVarPath = `/v2/admin/athlete-fixture-details/{athleteFixtureDetailsId}`
                .replace('{athleteFixtureDetailsId}', encodeURIComponent(String(athleteFixtureDetailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createOrUpdateAthleteFixtureDetailsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolves sports entities from external provider IDs by calling the Sports Service (GetOrCreate per entity), then applies the relevant CRUD operations in the Catalog Service.
         * @param {string} productId 
         * @param {ResolveExternalSportsEntitiesRequest} resolveExternalSportsEntitiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost: async (productId: string, resolveExternalSportsEntitiesRequest: ResolveExternalSportsEntitiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost', 'productId', productId)
            // verify required parameter 'resolveExternalSportsEntitiesRequest' is not null or undefined
            assertParamExists('v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost', 'resolveExternalSportsEntitiesRequest', resolveExternalSportsEntitiesRequest)
            const localVarPath = `/v2/admin/athlete-fixture-details/products/{productId}/from-external`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = resolveExternalSportsEntitiesRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {boolean} [includeExternalIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminAthleteFixtureDetailsProductsProductIdGet: async (productId: string, includeExternalIds?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminAthleteFixtureDetailsProductsProductIdGet', 'productId', productId)
            const localVarPath = `/v2/admin/athlete-fixture-details/products/{productId}`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeExternalIds !== undefined) {
                localVarQueryParameter['include_external_ids'] = includeExternalIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {CreateOrUpdateAthleteFixtureDetailsRequest} createOrUpdateAthleteFixtureDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminAthleteFixtureDetailsProductsProductIdPost: async (productId: string, createOrUpdateAthleteFixtureDetailsRequest: CreateOrUpdateAthleteFixtureDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminAthleteFixtureDetailsProductsProductIdPost', 'productId', productId)
            // verify required parameter 'createOrUpdateAthleteFixtureDetailsRequest' is not null or undefined
            assertParamExists('v2AdminAthleteFixtureDetailsProductsProductIdPost', 'createOrUpdateAthleteFixtureDetailsRequest', createOrUpdateAthleteFixtureDetailsRequest)
            const localVarPath = `/v2/admin/athlete-fixture-details/products/{productId}`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createOrUpdateAthleteFixtureDetailsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAthleteFixtureDetailsApi - functional programming interface
 */
export const AdminAthleteFixtureDetailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAthleteFixtureDetailsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} athleteFixtureDetailsId 
         * @param {CreateOrUpdateAthleteFixtureDetailsRequest} createOrUpdateAthleteFixtureDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut(athleteFixtureDetailsId: string, createOrUpdateAthleteFixtureDetailsRequest: CreateOrUpdateAthleteFixtureDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut(athleteFixtureDetailsId, createOrUpdateAthleteFixtureDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteFixtureDetailsApi.v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resolves sports entities from external provider IDs by calling the Sports Service (GetOrCreate per entity), then applies the relevant CRUD operations in the Catalog Service.
         * @param {string} productId 
         * @param {ResolveExternalSportsEntitiesRequest} resolveExternalSportsEntitiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost(productId: string, resolveExternalSportsEntitiesRequest: ResolveExternalSportsEntitiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost(productId, resolveExternalSportsEntitiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteFixtureDetailsApi.v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {boolean} [includeExternalIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminAthleteFixtureDetailsProductsProductIdGet(productId: string, includeExternalIds?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAthleteFixtureDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminAthleteFixtureDetailsProductsProductIdGet(productId, includeExternalIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteFixtureDetailsApi.v2AdminAthleteFixtureDetailsProductsProductIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {CreateOrUpdateAthleteFixtureDetailsRequest} createOrUpdateAthleteFixtureDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminAthleteFixtureDetailsProductsProductIdPost(productId: string, createOrUpdateAthleteFixtureDetailsRequest: CreateOrUpdateAthleteFixtureDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminAthleteFixtureDetailsProductsProductIdPost(productId, createOrUpdateAthleteFixtureDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAthleteFixtureDetailsApi.v2AdminAthleteFixtureDetailsProductsProductIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAthleteFixtureDetailsApi - factory interface
 */
export const AdminAthleteFixtureDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAthleteFixtureDetailsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut(requestParameters: AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut(requestParameters.athleteFixtureDetailsId, requestParameters.createOrUpdateAthleteFixtureDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolves sports entities from external provider IDs by calling the Sports Service (GetOrCreate per entity), then applies the relevant CRUD operations in the Catalog Service.
         * @param {AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdFromExternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost(requestParameters: AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdFromExternalPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost(requestParameters.productId, requestParameters.resolveExternalSportsEntitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminAthleteFixtureDetailsProductsProductIdGet(requestParameters: AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminAthleteFixtureDetails> {
            return localVarFp.v2AdminAthleteFixtureDetailsProductsProductIdGet(requestParameters.productId, requestParameters.includeExternalIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminAthleteFixtureDetailsProductsProductIdPost(requestParameters: AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminAthleteFixtureDetailsProductsProductIdPost(requestParameters.productId, requestParameters.createOrUpdateAthleteFixtureDetailsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut operation in AdminAthleteFixtureDetailsApi.
 */
export interface AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPutRequest {
    readonly athleteFixtureDetailsId: string

    readonly createOrUpdateAthleteFixtureDetailsRequest: CreateOrUpdateAthleteFixtureDetailsRequest
}

/**
 * Request parameters for v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost operation in AdminAthleteFixtureDetailsApi.
 */
export interface AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdFromExternalPostRequest {
    readonly productId: string

    readonly resolveExternalSportsEntitiesRequest: ResolveExternalSportsEntitiesRequest
}

/**
 * Request parameters for v2AdminAthleteFixtureDetailsProductsProductIdGet operation in AdminAthleteFixtureDetailsApi.
 */
export interface AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdGetRequest {
    readonly productId: string

    readonly includeExternalIds?: boolean
}

/**
 * Request parameters for v2AdminAthleteFixtureDetailsProductsProductIdPost operation in AdminAthleteFixtureDetailsApi.
 */
export interface AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdPostRequest {
    readonly productId: string

    readonly createOrUpdateAthleteFixtureDetailsRequest: CreateOrUpdateAthleteFixtureDetailsRequest
}

/**
 * AdminAthleteFixtureDetailsApi - object-oriented interface
 */
export class AdminAthleteFixtureDetailsApi extends BaseAPI {
    /**
     * 
     * @param {AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut(requestParameters: AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteFixtureDetailsApiFp(this.configuration).v2AdminAthleteFixtureDetailsAthleteFixtureDetailsIdPut(requestParameters.athleteFixtureDetailsId, requestParameters.createOrUpdateAthleteFixtureDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolves sports entities from external provider IDs by calling the Sports Service (GetOrCreate per entity), then applies the relevant CRUD operations in the Catalog Service.
     * @param {AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdFromExternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost(requestParameters: AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdFromExternalPostRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteFixtureDetailsApiFp(this.configuration).v2AdminAthleteFixtureDetailsProductsProductIdFromExternalPost(requestParameters.productId, requestParameters.resolveExternalSportsEntitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminAthleteFixtureDetailsProductsProductIdGet(requestParameters: AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteFixtureDetailsApiFp(this.configuration).v2AdminAthleteFixtureDetailsProductsProductIdGet(requestParameters.productId, requestParameters.includeExternalIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminAthleteFixtureDetailsProductsProductIdPost(requestParameters: AdminAthleteFixtureDetailsApiV2AdminAthleteFixtureDetailsProductsProductIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminAthleteFixtureDetailsApiFp(this.configuration).v2AdminAthleteFixtureDetailsProductsProductIdPost(requestParameters.productId, requestParameters.createOrUpdateAthleteFixtureDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminBiddersApi - axios parameter creator
 */
export const AdminBiddersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBiddersUserIdBlockPatch: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminBiddersUserIdBlockPatch', 'userId', userId)
            const localVarPath = `/v2/admin/bidders/{userId}/block`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBiddersUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminBiddersUserIdGet', 'userId', userId)
            const localVarPath = `/v2/admin/bidders/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBiddersUserIdUnblockPatch: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminBiddersUserIdUnblockPatch', 'userId', userId)
            const localVarPath = `/v2/admin/bidders/{userId}/unblock`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminBiddersApi - functional programming interface
 */
export const AdminBiddersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminBiddersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminBiddersUserIdBlockPatch(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBidder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminBiddersUserIdBlockPatch(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBiddersApi.v2AdminBiddersUserIdBlockPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminBiddersUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBidder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminBiddersUserIdGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBiddersApi.v2AdminBiddersUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminBiddersUserIdUnblockPatch(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBidder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminBiddersUserIdUnblockPatch(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBiddersApi.v2AdminBiddersUserIdUnblockPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminBiddersApi - factory interface
 */
export const AdminBiddersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminBiddersApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminBiddersApiV2AdminBiddersUserIdBlockPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBiddersUserIdBlockPatch(requestParameters: AdminBiddersApiV2AdminBiddersUserIdBlockPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBidder> {
            return localVarFp.v2AdminBiddersUserIdBlockPatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminBiddersApiV2AdminBiddersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBiddersUserIdGet(requestParameters: AdminBiddersApiV2AdminBiddersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBidder> {
            return localVarFp.v2AdminBiddersUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminBiddersApiV2AdminBiddersUserIdUnblockPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBiddersUserIdUnblockPatch(requestParameters: AdminBiddersApiV2AdminBiddersUserIdUnblockPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBidder> {
            return localVarFp.v2AdminBiddersUserIdUnblockPatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminBiddersUserIdBlockPatch operation in AdminBiddersApi.
 */
export interface AdminBiddersApiV2AdminBiddersUserIdBlockPatchRequest {
    readonly userId: string
}

/**
 * Request parameters for v2AdminBiddersUserIdGet operation in AdminBiddersApi.
 */
export interface AdminBiddersApiV2AdminBiddersUserIdGetRequest {
    readonly userId: string
}

/**
 * Request parameters for v2AdminBiddersUserIdUnblockPatch operation in AdminBiddersApi.
 */
export interface AdminBiddersApiV2AdminBiddersUserIdUnblockPatchRequest {
    readonly userId: string
}

/**
 * AdminBiddersApi - object-oriented interface
 */
export class AdminBiddersApi extends BaseAPI {
    /**
     * 
     * @param {AdminBiddersApiV2AdminBiddersUserIdBlockPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminBiddersUserIdBlockPatch(requestParameters: AdminBiddersApiV2AdminBiddersUserIdBlockPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminBiddersApiFp(this.configuration).v2AdminBiddersUserIdBlockPatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminBiddersApiV2AdminBiddersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminBiddersUserIdGet(requestParameters: AdminBiddersApiV2AdminBiddersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminBiddersApiFp(this.configuration).v2AdminBiddersUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminBiddersApiV2AdminBiddersUserIdUnblockPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminBiddersUserIdUnblockPatch(requestParameters: AdminBiddersApiV2AdminBiddersUserIdUnblockPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminBiddersApiFp(this.configuration).v2AdminBiddersUserIdUnblockPatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminClaimApi - axios parameter creator
 */
export const AdminClaimApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminClaimsBulkUsersUserIdPost: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('v2AdminClaimsBulkUsersUserIdPost', 'userId', userId)
            const localVarPath = `/v2/admin/claims/bulk/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminClaimsClaimIdDelete: async (claimId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('v2AdminClaimsClaimIdDelete', 'claimId', claimId)
            const localVarPath = `/v2/admin/claims/{claimId}`
                .replace('{claimId}', encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [userId] 
         * @param {string} [productId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminClaimsGet: async (userId?: string, productId?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminClaimApi - functional programming interface
 */
export const AdminClaimApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminClaimApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminClaimsBulkUsersUserIdPost(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminClaimsBulkUsersUserIdPost(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminClaimApi.v2AdminClaimsBulkUsersUserIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminClaimsClaimIdDelete(claimId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminClaimsClaimIdDelete(claimId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminClaimApi.v2AdminClaimsClaimIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [userId] 
         * @param {string} [productId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminClaimsGet(userId?: string, productId?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminClaimList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminClaimsGet(userId, productId, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminClaimApi.v2AdminClaimsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminClaimApi - factory interface
 */
export const AdminClaimApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminClaimApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminClaimApiV2AdminClaimsBulkUsersUserIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminClaimsBulkUsersUserIdPost(requestParameters: AdminClaimApiV2AdminClaimsBulkUsersUserIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminClaimsBulkUsersUserIdPost(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminClaimApiV2AdminClaimsClaimIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminClaimsClaimIdDelete(requestParameters: AdminClaimApiV2AdminClaimsClaimIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminClaimsClaimIdDelete(requestParameters.claimId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminClaimApiV2AdminClaimsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminClaimsGet(requestParameters: AdminClaimApiV2AdminClaimsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminClaimList> {
            return localVarFp.v2AdminClaimsGet(requestParameters.userId, requestParameters.productId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminClaimsBulkUsersUserIdPost operation in AdminClaimApi.
 */
export interface AdminClaimApiV2AdminClaimsBulkUsersUserIdPostRequest {
    readonly userId: string
}

/**
 * Request parameters for v2AdminClaimsClaimIdDelete operation in AdminClaimApi.
 */
export interface AdminClaimApiV2AdminClaimsClaimIdDeleteRequest {
    readonly claimId: string
}

/**
 * Request parameters for v2AdminClaimsGet operation in AdminClaimApi.
 */
export interface AdminClaimApiV2AdminClaimsGetRequest {
    readonly userId?: string

    readonly productId?: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * AdminClaimApi - object-oriented interface
 */
export class AdminClaimApi extends BaseAPI {
    /**
     * 
     * @param {AdminClaimApiV2AdminClaimsBulkUsersUserIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminClaimsBulkUsersUserIdPost(requestParameters: AdminClaimApiV2AdminClaimsBulkUsersUserIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminClaimApiFp(this.configuration).v2AdminClaimsBulkUsersUserIdPost(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminClaimApiV2AdminClaimsClaimIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminClaimsClaimIdDelete(requestParameters: AdminClaimApiV2AdminClaimsClaimIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminClaimApiFp(this.configuration).v2AdminClaimsClaimIdDelete(requestParameters.claimId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminClaimApiV2AdminClaimsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminClaimsGet(requestParameters: AdminClaimApiV2AdminClaimsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminClaimApiFp(this.configuration).v2AdminClaimsGet(requestParameters.userId, requestParameters.productId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventMockupsApi - axios parameter creator
 */
export const AdminEventMockupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {SortEventMockupOn} [sortOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [searchTerm] 
         * @param {string} [teamId] 
         * @param {string} [partnershipManagerId] 
         * @param {EventMockupsStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminEventsMockupsGet: async (offset?: number, pageSize?: number, sortOn?: SortEventMockupOn, sortDirection?: SortDirection, searchTerm?: string, teamId?: string, partnershipManagerId?: string, status?: EventMockupsStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/events/mockups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortOn !== undefined) {
                localVarQueryParameter['sort_on'] = sortOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (partnershipManagerId !== undefined) {
                localVarQueryParameter['partnership_manager_id'] = partnershipManagerId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventMockupsApi - functional programming interface
 */
export const AdminEventMockupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventMockupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {SortEventMockupOn} [sortOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [searchTerm] 
         * @param {string} [teamId] 
         * @param {string} [partnershipManagerId] 
         * @param {EventMockupsStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminEventsMockupsGet(offset?: number, pageSize?: number, sortOn?: SortEventMockupOn, sortDirection?: SortDirection, searchTerm?: string, teamId?: string, partnershipManagerId?: string, status?: EventMockupsStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventMockupList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminEventsMockupsGet(offset, pageSize, sortOn, sortDirection, searchTerm, teamId, partnershipManagerId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventMockupsApi.v2AdminEventsMockupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventMockupsApi - factory interface
 */
export const AdminEventMockupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventMockupsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminEventMockupsApiV2AdminEventsMockupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminEventsMockupsGet(requestParameters: AdminEventMockupsApiV2AdminEventsMockupsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EventMockupList> {
            return localVarFp.v2AdminEventsMockupsGet(requestParameters.offset, requestParameters.pageSize, requestParameters.sortOn, requestParameters.sortDirection, requestParameters.searchTerm, requestParameters.teamId, requestParameters.partnershipManagerId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminEventsMockupsGet operation in AdminEventMockupsApi.
 */
export interface AdminEventMockupsApiV2AdminEventsMockupsGetRequest {
    readonly offset?: number

    readonly pageSize?: number

    readonly sortOn?: SortEventMockupOn

    readonly sortDirection?: SortDirection

    readonly searchTerm?: string

    readonly teamId?: string

    readonly partnershipManagerId?: string

    readonly status?: EventMockupsStatus
}

/**
 * AdminEventMockupsApi - object-oriented interface
 */
export class AdminEventMockupsApi extends BaseAPI {
    /**
     * 
     * @param {AdminEventMockupsApiV2AdminEventsMockupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminEventsMockupsGet(requestParameters: AdminEventMockupsApiV2AdminEventsMockupsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEventMockupsApiFp(this.configuration).v2AdminEventsMockupsGet(requestParameters.offset, requestParameters.pageSize, requestParameters.sortOn, requestParameters.sortDirection, requestParameters.searchTerm, requestParameters.teamId, requestParameters.partnershipManagerId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFixtureDetailsApi - axios parameter creator
 */
export const AdminFixtureDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsEventsEventIdGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('v2AdminFixtureDetailsEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/v2/admin/fixture-details/events/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {CreateOrUpdateFixtureDetailsRequest} createOrUpdateFixtureDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsEventsEventIdPost: async (eventId: string, createOrUpdateFixtureDetailsRequest: CreateOrUpdateFixtureDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('v2AdminFixtureDetailsEventsEventIdPost', 'eventId', eventId)
            // verify required parameter 'createOrUpdateFixtureDetailsRequest' is not null or undefined
            assertParamExists('v2AdminFixtureDetailsEventsEventIdPost', 'createOrUpdateFixtureDetailsRequest', createOrUpdateFixtureDetailsRequest)
            const localVarPath = `/v2/admin/fixture-details/events/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createOrUpdateFixtureDetailsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fixtureDetailsId 
         * @param {CreateOrUpdateFixtureDetailsRequest} createOrUpdateFixtureDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsFixtureDetailsIdPut: async (fixtureDetailsId: string, createOrUpdateFixtureDetailsRequest: CreateOrUpdateFixtureDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureDetailsId' is not null or undefined
            assertParamExists('v2AdminFixtureDetailsFixtureDetailsIdPut', 'fixtureDetailsId', fixtureDetailsId)
            // verify required parameter 'createOrUpdateFixtureDetailsRequest' is not null or undefined
            assertParamExists('v2AdminFixtureDetailsFixtureDetailsIdPut', 'createOrUpdateFixtureDetailsRequest', createOrUpdateFixtureDetailsRequest)
            const localVarPath = `/v2/admin/fixture-details/{fixtureDetailsId}`
                .replace('{fixtureDetailsId}', encodeURIComponent(String(fixtureDetailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createOrUpdateFixtureDetailsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsProductsProductIdDelete: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminFixtureDetailsProductsProductIdDelete', 'productId', productId)
            const localVarPath = `/v2/admin/fixture-details/products/{productId}`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsProductsProductIdGet: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminFixtureDetailsProductsProductIdGet', 'productId', productId)
            const localVarPath = `/v2/admin/fixture-details/products/{productId}`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFixtureDetailsApi - functional programming interface
 */
export const AdminFixtureDetailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFixtureDetailsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminFixtureDetailsEventsEventIdGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFixtureDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminFixtureDetailsEventsEventIdGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixtureDetailsApi.v2AdminFixtureDetailsEventsEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {CreateOrUpdateFixtureDetailsRequest} createOrUpdateFixtureDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminFixtureDetailsEventsEventIdPost(eventId: string, createOrUpdateFixtureDetailsRequest: CreateOrUpdateFixtureDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminFixtureDetailsEventsEventIdPost(eventId, createOrUpdateFixtureDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixtureDetailsApi.v2AdminFixtureDetailsEventsEventIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fixtureDetailsId 
         * @param {CreateOrUpdateFixtureDetailsRequest} createOrUpdateFixtureDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminFixtureDetailsFixtureDetailsIdPut(fixtureDetailsId: string, createOrUpdateFixtureDetailsRequest: CreateOrUpdateFixtureDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFixtureDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminFixtureDetailsFixtureDetailsIdPut(fixtureDetailsId, createOrUpdateFixtureDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixtureDetailsApi.v2AdminFixtureDetailsFixtureDetailsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminFixtureDetailsProductsProductIdDelete(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminFixtureDetailsProductsProductIdDelete(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixtureDetailsApi.v2AdminFixtureDetailsProductsProductIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminFixtureDetailsProductsProductIdGet(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFixtureDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminFixtureDetailsProductsProductIdGet(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFixtureDetailsApi.v2AdminFixtureDetailsProductsProductIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFixtureDetailsApi - factory interface
 */
export const AdminFixtureDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFixtureDetailsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsEventsEventIdGet(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminFixtureDetails> {
            return localVarFp.v2AdminFixtureDetailsEventsEventIdGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsEventsEventIdPost(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminFixtureDetailsEventsEventIdPost(requestParameters.eventId, requestParameters.createOrUpdateFixtureDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsFixtureDetailsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsFixtureDetailsIdPut(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsFixtureDetailsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminFixtureDetails> {
            return localVarFp.v2AdminFixtureDetailsFixtureDetailsIdPut(requestParameters.fixtureDetailsId, requestParameters.createOrUpdateFixtureDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsProductsProductIdDelete(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminFixtureDetailsProductsProductIdDelete(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminFixtureDetailsProductsProductIdGet(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminFixtureDetails> {
            return localVarFp.v2AdminFixtureDetailsProductsProductIdGet(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminFixtureDetailsEventsEventIdGet operation in AdminFixtureDetailsApi.
 */
export interface AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdGetRequest {
    readonly eventId: string
}

/**
 * Request parameters for v2AdminFixtureDetailsEventsEventIdPost operation in AdminFixtureDetailsApi.
 */
export interface AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdPostRequest {
    readonly eventId: string

    readonly createOrUpdateFixtureDetailsRequest: CreateOrUpdateFixtureDetailsRequest
}

/**
 * Request parameters for v2AdminFixtureDetailsFixtureDetailsIdPut operation in AdminFixtureDetailsApi.
 */
export interface AdminFixtureDetailsApiV2AdminFixtureDetailsFixtureDetailsIdPutRequest {
    readonly fixtureDetailsId: string

    readonly createOrUpdateFixtureDetailsRequest: CreateOrUpdateFixtureDetailsRequest
}

/**
 * Request parameters for v2AdminFixtureDetailsProductsProductIdDelete operation in AdminFixtureDetailsApi.
 */
export interface AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdDeleteRequest {
    readonly productId: string
}

/**
 * Request parameters for v2AdminFixtureDetailsProductsProductIdGet operation in AdminFixtureDetailsApi.
 */
export interface AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdGetRequest {
    readonly productId: string
}

/**
 * AdminFixtureDetailsApi - object-oriented interface
 */
export class AdminFixtureDetailsApi extends BaseAPI {
    /**
     * 
     * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminFixtureDetailsEventsEventIdGet(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminFixtureDetailsApiFp(this.configuration).v2AdminFixtureDetailsEventsEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminFixtureDetailsEventsEventIdPost(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsEventsEventIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminFixtureDetailsApiFp(this.configuration).v2AdminFixtureDetailsEventsEventIdPost(requestParameters.eventId, requestParameters.createOrUpdateFixtureDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsFixtureDetailsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminFixtureDetailsFixtureDetailsIdPut(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsFixtureDetailsIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminFixtureDetailsApiFp(this.configuration).v2AdminFixtureDetailsFixtureDetailsIdPut(requestParameters.fixtureDetailsId, requestParameters.createOrUpdateFixtureDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminFixtureDetailsProductsProductIdDelete(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminFixtureDetailsApiFp(this.configuration).v2AdminFixtureDetailsProductsProductIdDelete(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminFixtureDetailsProductsProductIdGet(requestParameters: AdminFixtureDetailsApiV2AdminFixtureDetailsProductsProductIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminFixtureDetailsApiFp(this.configuration).v2AdminFixtureDetailsProductsProductIdGet(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminMaxBidsApi - axios parameter creator
 */
export const AdminMaxBidsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {string} [userId] 
         * @param {string} [listingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBidsMaxGet: async (offSet?: number, pageSize?: number, searchTerm?: string, userId?: string, listingId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/bids/max`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['off_set'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (listingId !== undefined) {
                localVarQueryParameter['listing_id'] = listingId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} maxBidId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBidsMaxMaxBidIdDeactivatePatch: async (maxBidId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'maxBidId' is not null or undefined
            assertParamExists('v2AdminBidsMaxMaxBidIdDeactivatePatch', 'maxBidId', maxBidId)
            const localVarPath = `/v2/admin/bids/max/{maxBidId}/deactivate`
                .replace('{maxBidId}', encodeURIComponent(String(maxBidId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMaxBidsApi - functional programming interface
 */
export const AdminMaxBidsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMaxBidsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {string} [userId] 
         * @param {string} [listingId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminBidsMaxGet(offSet?: number, pageSize?: number, searchTerm?: string, userId?: string, listingId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMaxBidList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminBidsMaxGet(offSet, pageSize, searchTerm, userId, listingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMaxBidsApi.v2AdminBidsMaxGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} maxBidId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminBidsMaxMaxBidIdDeactivatePatch(maxBidId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminBidsMaxMaxBidIdDeactivatePatch(maxBidId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMaxBidsApi.v2AdminBidsMaxMaxBidIdDeactivatePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminMaxBidsApi - factory interface
 */
export const AdminMaxBidsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMaxBidsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminMaxBidsApiV2AdminBidsMaxGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBidsMaxGet(requestParameters: AdminMaxBidsApiV2AdminBidsMaxGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminMaxBidList> {
            return localVarFp.v2AdminBidsMaxGet(requestParameters.offSet, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.userId, requestParameters.listingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminMaxBidsApiV2AdminBidsMaxMaxBidIdDeactivatePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminBidsMaxMaxBidIdDeactivatePatch(requestParameters: AdminMaxBidsApiV2AdminBidsMaxMaxBidIdDeactivatePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminBidsMaxMaxBidIdDeactivatePatch(requestParameters.maxBidId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminBidsMaxGet operation in AdminMaxBidsApi.
 */
export interface AdminMaxBidsApiV2AdminBidsMaxGetRequest {
    readonly offSet?: number

    readonly pageSize?: number

    readonly searchTerm?: string

    readonly userId?: string

    readonly listingId?: string
}

/**
 * Request parameters for v2AdminBidsMaxMaxBidIdDeactivatePatch operation in AdminMaxBidsApi.
 */
export interface AdminMaxBidsApiV2AdminBidsMaxMaxBidIdDeactivatePatchRequest {
    readonly maxBidId: string
}

/**
 * AdminMaxBidsApi - object-oriented interface
 */
export class AdminMaxBidsApi extends BaseAPI {
    /**
     * 
     * @param {AdminMaxBidsApiV2AdminBidsMaxGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminBidsMaxGet(requestParameters: AdminMaxBidsApiV2AdminBidsMaxGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminMaxBidsApiFp(this.configuration).v2AdminBidsMaxGet(requestParameters.offSet, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.userId, requestParameters.listingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminMaxBidsApiV2AdminBidsMaxMaxBidIdDeactivatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminBidsMaxMaxBidIdDeactivatePatch(requestParameters: AdminMaxBidsApiV2AdminBidsMaxMaxBidIdDeactivatePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminMaxBidsApiFp(this.configuration).v2AdminBidsMaxMaxBidIdDeactivatePatch(requestParameters.maxBidId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOutboxMessagesApi - axios parameter creator
 */
export const AdminOutboxMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeleteOutboxMessagesRequest} deleteOutboxMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminCatalogOutboxMessagesDeleteDelete: async (deleteOutboxMessagesRequest: DeleteOutboxMessagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteOutboxMessagesRequest' is not null or undefined
            assertParamExists('v2AdminCatalogOutboxMessagesDeleteDelete', 'deleteOutboxMessagesRequest', deleteOutboxMessagesRequest)
            const localVarPath = `/v2/admin/catalog-outbox-messages/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = deleteOutboxMessagesRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OutboxMessageState} [status] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminCatalogOutboxMessagesGet: async (status?: OutboxMessageState, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/catalog-outbox-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetOutboxMessagesRequest} resetOutboxMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminCatalogOutboxMessagesResetPatch: async (resetOutboxMessagesRequest: ResetOutboxMessagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetOutboxMessagesRequest' is not null or undefined
            assertParamExists('v2AdminCatalogOutboxMessagesResetPatch', 'resetOutboxMessagesRequest', resetOutboxMessagesRequest)
            const localVarPath = `/v2/admin/catalog-outbox-messages/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = resetOutboxMessagesRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOutboxMessagesApi - functional programming interface
 */
export const AdminOutboxMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOutboxMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeleteOutboxMessagesRequest} deleteOutboxMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminCatalogOutboxMessagesDeleteDelete(deleteOutboxMessagesRequest: DeleteOutboxMessagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOutboxMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminCatalogOutboxMessagesDeleteDelete(deleteOutboxMessagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOutboxMessagesApi.v2AdminCatalogOutboxMessagesDeleteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OutboxMessageState} [status] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminCatalogOutboxMessagesGet(status?: OutboxMessageState, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutboxMessageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminCatalogOutboxMessagesGet(status, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOutboxMessagesApi.v2AdminCatalogOutboxMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetOutboxMessagesRequest} resetOutboxMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminCatalogOutboxMessagesResetPatch(resetOutboxMessagesRequest: ResetOutboxMessagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetOutboxMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminCatalogOutboxMessagesResetPatch(resetOutboxMessagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOutboxMessagesApi.v2AdminCatalogOutboxMessagesResetPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOutboxMessagesApi - factory interface
 */
export const AdminOutboxMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOutboxMessagesApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesDeleteDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminCatalogOutboxMessagesDeleteDelete(requestParameters: AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesDeleteDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteOutboxMessages> {
            return localVarFp.v2AdminCatalogOutboxMessagesDeleteDelete(requestParameters.deleteOutboxMessagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminCatalogOutboxMessagesGet(requestParameters: AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OutboxMessageList> {
            return localVarFp.v2AdminCatalogOutboxMessagesGet(requestParameters.status, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesResetPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminCatalogOutboxMessagesResetPatch(requestParameters: AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesResetPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResetOutboxMessages> {
            return localVarFp.v2AdminCatalogOutboxMessagesResetPatch(requestParameters.resetOutboxMessagesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminCatalogOutboxMessagesDeleteDelete operation in AdminOutboxMessagesApi.
 */
export interface AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesDeleteDeleteRequest {
    readonly deleteOutboxMessagesRequest: DeleteOutboxMessagesRequest
}

/**
 * Request parameters for v2AdminCatalogOutboxMessagesGet operation in AdminOutboxMessagesApi.
 */
export interface AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesGetRequest {
    readonly status?: OutboxMessageState

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2AdminCatalogOutboxMessagesResetPatch operation in AdminOutboxMessagesApi.
 */
export interface AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesResetPatchRequest {
    readonly resetOutboxMessagesRequest: ResetOutboxMessagesRequest
}

/**
 * AdminOutboxMessagesApi - object-oriented interface
 */
export class AdminOutboxMessagesApi extends BaseAPI {
    /**
     * 
     * @param {AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminCatalogOutboxMessagesDeleteDelete(requestParameters: AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesDeleteDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminOutboxMessagesApiFp(this.configuration).v2AdminCatalogOutboxMessagesDeleteDelete(requestParameters.deleteOutboxMessagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminCatalogOutboxMessagesGet(requestParameters: AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOutboxMessagesApiFp(this.configuration).v2AdminCatalogOutboxMessagesGet(requestParameters.status, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesResetPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminCatalogOutboxMessagesResetPatch(requestParameters: AdminOutboxMessagesApiV2AdminCatalogOutboxMessagesResetPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminOutboxMessagesApiFp(this.configuration).v2AdminCatalogOutboxMessagesResetPatch(requestParameters.resetOutboxMessagesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductListingsApi - axios parameter creator
 */
export const AdminProductListingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add categories to a selection of product listings
         * @param {AddCategoriesToProductListingsRequest} addCategoriesToProductListingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsCategoriesPost: async (addCategoriesToProductListingsRequest: AddCategoriesToProductListingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addCategoriesToProductListingsRequest' is not null or undefined
            assertParamExists('v2AdminProductListingsCategoriesPost', 'addCategoriesToProductListingsRequest', addCategoriesToProductListingsRequest)
            const localVarPath = `/v2/admin/product-listings/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = addCategoriesToProductListingsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a product listing
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v2AdminProductListingsIdDelete', 'id', id)
            const localVarPath = `/v2/admin/product-listings/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a product listing by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v2AdminProductListingsIdGet', 'id', id)
            const localVarPath = `/v2/admin/product-listings/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move a product listing to a different event
         * @param {string} id 
         * @param {MoveProductListingRequest} moveProductListingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsIdMovePost: async (id: string, moveProductListingRequest: MoveProductListingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v2AdminProductListingsIdMovePost', 'id', id)
            // verify required parameter 'moveProductListingRequest' is not null or undefined
            assertParamExists('v2AdminProductListingsIdMovePost', 'moveProductListingRequest', moveProductListingRequest)
            const localVarPath = `/v2/admin/product-listings/{id}/move`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = moveProductListingRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates some parts of the product listing
         * @param {string} id 
         * @param {UpdateProductListingRequest} updateProductListingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsIdPatch: async (id: string, updateProductListingRequest: UpdateProductListingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v2AdminProductListingsIdPatch', 'id', id)
            // verify required parameter 'updateProductListingRequest' is not null or undefined
            assertParamExists('v2AdminProductListingsIdPatch', 'updateProductListingRequest', updateProductListingRequest)
            const localVarPath = `/v2/admin/product-listings/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateProductListingRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductListingsApi - functional programming interface
 */
export const AdminProductListingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductListingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add categories to a selection of product listings
         * @param {AddCategoriesToProductListingsRequest} addCategoriesToProductListingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductListingsCategoriesPost(addCategoriesToProductListingsRequest: AddCategoriesToProductListingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductListingsCategoriesPost(addCategoriesToProductListingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductListingsApi.v2AdminProductListingsCategoriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a product listing
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductListingsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductListingsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductListingsApi.v2AdminProductListingsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a product listing by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductListingsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminListing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductListingsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductListingsApi.v2AdminProductListingsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move a product listing to a different event
         * @param {string} id 
         * @param {MoveProductListingRequest} moveProductListingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductListingsIdMovePost(id: string, moveProductListingRequest: MoveProductListingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductListingsIdMovePost(id, moveProductListingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductListingsApi.v2AdminProductListingsIdMovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates some parts of the product listing
         * @param {string} id 
         * @param {UpdateProductListingRequest} updateProductListingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductListingsIdPatch(id: string, updateProductListingRequest: UpdateProductListingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductListingsIdPatch(id, updateProductListingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductListingsApi.v2AdminProductListingsIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductListingsApi - factory interface
 */
export const AdminProductListingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductListingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add categories to a selection of product listings
         * @param {AdminProductListingsApiV2AdminProductListingsCategoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsCategoriesPost(requestParameters: AdminProductListingsApiV2AdminProductListingsCategoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductListingsCategoriesPost(requestParameters.addCategoriesToProductListingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a product listing
         * @param {AdminProductListingsApiV2AdminProductListingsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsIdDelete(requestParameters: AdminProductListingsApiV2AdminProductListingsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductListingsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a product listing by id
         * @param {AdminProductListingsApiV2AdminProductListingsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsIdGet(requestParameters: AdminProductListingsApiV2AdminProductListingsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminListing> {
            return localVarFp.v2AdminProductListingsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move a product listing to a different event
         * @param {AdminProductListingsApiV2AdminProductListingsIdMovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsIdMovePost(requestParameters: AdminProductListingsApiV2AdminProductListingsIdMovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductListingsIdMovePost(requestParameters.id, requestParameters.moveProductListingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates some parts of the product listing
         * @param {AdminProductListingsApiV2AdminProductListingsIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductListingsIdPatch(requestParameters: AdminProductListingsApiV2AdminProductListingsIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductListingsIdPatch(requestParameters.id, requestParameters.updateProductListingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminProductListingsCategoriesPost operation in AdminProductListingsApi.
 */
export interface AdminProductListingsApiV2AdminProductListingsCategoriesPostRequest {
    readonly addCategoriesToProductListingsRequest: AddCategoriesToProductListingsRequest
}

/**
 * Request parameters for v2AdminProductListingsIdDelete operation in AdminProductListingsApi.
 */
export interface AdminProductListingsApiV2AdminProductListingsIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for v2AdminProductListingsIdGet operation in AdminProductListingsApi.
 */
export interface AdminProductListingsApiV2AdminProductListingsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for v2AdminProductListingsIdMovePost operation in AdminProductListingsApi.
 */
export interface AdminProductListingsApiV2AdminProductListingsIdMovePostRequest {
    readonly id: string

    readonly moveProductListingRequest: MoveProductListingRequest
}

/**
 * Request parameters for v2AdminProductListingsIdPatch operation in AdminProductListingsApi.
 */
export interface AdminProductListingsApiV2AdminProductListingsIdPatchRequest {
    /**
     * 
     */
    readonly id: string

    /**
     * 
     */
    readonly updateProductListingRequest: UpdateProductListingRequest
}

/**
 * AdminProductListingsApi - object-oriented interface
 */
export class AdminProductListingsApi extends BaseAPI {
    /**
     * 
     * @summary Add categories to a selection of product listings
     * @param {AdminProductListingsApiV2AdminProductListingsCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductListingsCategoriesPost(requestParameters: AdminProductListingsApiV2AdminProductListingsCategoriesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductListingsApiFp(this.configuration).v2AdminProductListingsCategoriesPost(requestParameters.addCategoriesToProductListingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a product listing
     * @param {AdminProductListingsApiV2AdminProductListingsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductListingsIdDelete(requestParameters: AdminProductListingsApiV2AdminProductListingsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminProductListingsApiFp(this.configuration).v2AdminProductListingsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a product listing by id
     * @param {AdminProductListingsApiV2AdminProductListingsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductListingsIdGet(requestParameters: AdminProductListingsApiV2AdminProductListingsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductListingsApiFp(this.configuration).v2AdminProductListingsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move a product listing to a different event
     * @param {AdminProductListingsApiV2AdminProductListingsIdMovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductListingsIdMovePost(requestParameters: AdminProductListingsApiV2AdminProductListingsIdMovePostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductListingsApiFp(this.configuration).v2AdminProductListingsIdMovePost(requestParameters.id, requestParameters.moveProductListingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates some parts of the product listing
     * @param {AdminProductListingsApiV2AdminProductListingsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductListingsIdPatch(requestParameters: AdminProductListingsApiV2AdminProductListingsIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductListingsApiFp(this.configuration).v2AdminProductListingsIdPatch(requestParameters.id, requestParameters.updateProductListingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductsApi - axios parameter creator
 */
export const AdminProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GenerateAiProductsDescriptionsRequest} generateAiProductsDescriptionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsAiDescriptionsPost: async (generateAiProductsDescriptionsRequest: GenerateAiProductsDescriptionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAiProductsDescriptionsRequest' is not null or undefined
            assertParamExists('v2AdminProductsAiDescriptionsPost', 'generateAiProductsDescriptionsRequest', generateAiProductsDescriptionsRequest)
            const localVarPath = `/v2/admin/products/ai-descriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = generateAiProductsDescriptionsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateProductMediaUrlsRequest} bulkUpdateProductMediaUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsBulkUploadMediaContentsPut: async (bulkUpdateProductMediaUrlsRequest: BulkUpdateProductMediaUrlsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateProductMediaUrlsRequest' is not null or undefined
            assertParamExists('v2AdminProductsBulkUploadMediaContentsPut', 'bulkUpdateProductMediaUrlsRequest', bulkUpdateProductMediaUrlsRequest)
            const localVarPath = `/v2/admin/products/bulk-upload/media-contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = bulkUpdateProductMediaUrlsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paginated list endpoint for showing and filtering of all products
         * @param {SortProductOn} [sortProductOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [searchTerm] 
         * @param {string} [teamId] 
         * @param {boolean} [hasStock] 
         * @param {string} [athleteId] 
         * @param {string} [shippingOfficeId] 
         * @param {boolean} [hasListings] 
         * @param {boolean} [isLinkedToFrame] 
         * @param {FramingType} [framingType] 
         * @param {boolean} [isReceived] 
         * @param {ProductSerialType} [serialType] 
         * @param {Array<InventoryLocationType>} [locationTypes] 
         * @param {Array<string>} [categoryIds] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsGet: async (sortProductOn?: SortProductOn, sortDirection?: SortDirection, searchTerm?: string, teamId?: string, hasStock?: boolean, athleteId?: string, shippingOfficeId?: string, hasListings?: boolean, isLinkedToFrame?: boolean, framingType?: FramingType, isReceived?: boolean, serialType?: ProductSerialType, locationTypes?: Array<InventoryLocationType>, categoryIds?: Array<string>, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortProductOn !== undefined) {
                localVarQueryParameter['sort_product_on'] = sortProductOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (hasStock !== undefined) {
                localVarQueryParameter['has_stock'] = hasStock;
            }

            if (athleteId !== undefined) {
                localVarQueryParameter['athlete_id'] = athleteId;
            }

            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shipping_office_id'] = shippingOfficeId;
            }

            if (hasListings !== undefined) {
                localVarQueryParameter['has_listings'] = hasListings;
            }

            if (isLinkedToFrame !== undefined) {
                localVarQueryParameter['is_linked_to_frame'] = isLinkedToFrame;
            }

            if (framingType !== undefined) {
                localVarQueryParameter['framing_type'] = framingType;
            }

            if (isReceived !== undefined) {
                localVarQueryParameter['is_received'] = isReceived;
            }

            if (serialType !== undefined) {
                localVarQueryParameter['serial_type'] = serialType;
            }

            if (locationTypes) {
                localVarQueryParameter['location_types'] = locationTypes;
            }

            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a product by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v2AdminProductsIdGet', 'id', id)
            const localVarPath = `/v2/admin/products/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [baseUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsMedia360ZipGet: async (baseUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/products/media/360-zip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (baseUrl !== undefined) {
                localVarQueryParameter['base_url'] = baseUrl;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a product
         * @param {CreateNewProductRequest} createNewProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsPost: async (createNewProductRequest: CreateNewProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNewProductRequest' is not null or undefined
            assertParamExists('v2AdminProductsPost', 'createNewProductRequest', createNewProductRequest)
            const localVarPath = `/v2/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = createNewProductRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {ProductAiDescriptionRequest} productAiDescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdAiDescriptionPost: async (productId: string, productAiDescriptionRequest: ProductAiDescriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdAiDescriptionPost', 'productId', productId)
            // verify required parameter 'productAiDescriptionRequest' is not null or undefined
            assertParamExists('v2AdminProductsProductIdAiDescriptionPost', 'productAiDescriptionRequest', productAiDescriptionRequest)
            const localVarPath = `/v2/admin/products/{productId}/ai-description`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = productAiDescriptionRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates product inventory location.
         * @param {string} productId 
         * @param {UpdateInventoryLocationRequest} updateInventoryLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdInventoryLocationPut: async (productId: string, updateInventoryLocationRequest: UpdateInventoryLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdInventoryLocationPut', 'productId', productId)
            // verify required parameter 'updateInventoryLocationRequest' is not null or undefined
            assertParamExists('v2AdminProductsProductIdInventoryLocationPut', 'updateInventoryLocationRequest', updateInventoryLocationRequest)
            const localVarPath = `/v2/admin/products/{productId}/inventory/location`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateInventoryLocationRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] links a framed product to a frame If the guid is empty it removes the existing link
         * @param {string} productId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdLinkFramedProductPatch: async (productId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdLinkFramedProductPatch', 'productId', productId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('v2AdminProductsProductIdLinkFramedProductPatch', 'body', body)
            const localVarPath = `/v2/admin/products/{productId}/link-framed-product`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = body

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Gets all linked frames to a product
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdLinkedFramesGet: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdLinkedFramesGet', 'productId', productId)
            const localVarPath = `/v2/admin/products/{productId}/linked-frames`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Replace a products media-content
         * @param {string} productId The id of the product
         * @param {Array<AdminMediaContentRequest>} adminMediaContentRequest A Cancellation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdMediaContentPatch: async (productId: string, adminMediaContentRequest: Array<AdminMediaContentRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdMediaContentPatch', 'productId', productId)
            // verify required parameter 'adminMediaContentRequest' is not null or undefined
            assertParamExists('v2AdminProductsProductIdMediaContentPatch', 'adminMediaContentRequest', adminMediaContentRequest)
            const localVarPath = `/v2/admin/products/{productId}/media-content`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = adminMediaContentRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {UpdateProductMediaUrlsRequest} updateProductMediaUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdMediaContentUrlsPut: async (productId: string, updateProductMediaUrlsRequest: UpdateProductMediaUrlsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdMediaContentUrlsPut', 'productId', productId)
            // verify required parameter 'updateProductMediaUrlsRequest' is not null or undefined
            assertParamExists('v2AdminProductsProductIdMediaContentUrlsPut', 'updateProductMediaUrlsRequest', updateProductMediaUrlsRequest)
            const localVarPath = `/v2/admin/products/{productId}/media-content-urls`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateProductMediaUrlsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {SwitchProductMediaRequest} switchProductMediaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdMediaSwitchPost: async (productId: string, switchProductMediaRequest: SwitchProductMediaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdMediaSwitchPost', 'productId', productId)
            // verify required parameter 'switchProductMediaRequest' is not null or undefined
            assertParamExists('v2AdminProductsProductIdMediaSwitchPost', 'switchProductMediaRequest', switchProductMediaRequest)
            const localVarPath = `/v2/admin/products/{productId}/media/switch`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = switchProductMediaRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create (or update) this product\'s stock lot in Odoo
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdOdooPost: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdOdooPost', 'productId', productId)
            const localVarPath = `/v2/admin/products/{productId}/odoo`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates some parts of the product
         * @param {string} productId 
         * @param {UpdateNewProductRequest} updateNewProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdPatch: async (productId: string, updateNewProductRequest: UpdateNewProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdPatch', 'productId', productId)
            // verify required parameter 'updateNewProductRequest' is not null or undefined
            assertParamExists('v2AdminProductsProductIdPatch', 'updateNewProductRequest', updateNewProductRequest)
            const localVarPath = `/v2/admin/products/{productId}`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateNewProductRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {TranslateProductTextsRequest} translateProductTextsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdTranslationsPost: async (productId: string, translateProductTextsRequest: TranslateProductTextsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2AdminProductsProductIdTranslationsPost', 'productId', productId)
            // verify required parameter 'translateProductTextsRequest' is not null or undefined
            assertParamExists('v2AdminProductsProductIdTranslationsPost', 'translateProductTextsRequest', translateProductTextsRequest)
            const localVarPath = `/v2/admin/products/{productId}/translations`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = translateProductTextsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Gets scan data for a barcode scan
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsSerialScandataGet: async (serial: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('v2AdminProductsSerialScandataGet', 'serial', serial)
            const localVarPath = `/v2/admin/products/{serial}/scandata`
                .replace('{serial}', encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductsApi - functional programming interface
 */
export const AdminProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GenerateAiProductsDescriptionsRequest} generateAiProductsDescriptionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsAiDescriptionsPost(generateAiProductsDescriptionsRequest: GenerateAiProductsDescriptionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsAiDescriptionsPost(generateAiProductsDescriptionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsAiDescriptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkUpdateProductMediaUrlsRequest} bulkUpdateProductMediaUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsBulkUploadMediaContentsPut(bulkUpdateProductMediaUrlsRequest: BulkUpdateProductMediaUrlsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsBulkUploadMediaContentsPut(bulkUpdateProductMediaUrlsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsBulkUploadMediaContentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Paginated list endpoint for showing and filtering of all products
         * @param {SortProductOn} [sortProductOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [searchTerm] 
         * @param {string} [teamId] 
         * @param {boolean} [hasStock] 
         * @param {string} [athleteId] 
         * @param {string} [shippingOfficeId] 
         * @param {boolean} [hasListings] 
         * @param {boolean} [isLinkedToFrame] 
         * @param {FramingType} [framingType] 
         * @param {boolean} [isReceived] 
         * @param {ProductSerialType} [serialType] 
         * @param {Array<InventoryLocationType>} [locationTypes] 
         * @param {Array<string>} [categoryIds] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsGet(sortProductOn?: SortProductOn, sortDirection?: SortDirection, searchTerm?: string, teamId?: string, hasStock?: boolean, athleteId?: string, shippingOfficeId?: string, hasListings?: boolean, isLinkedToFrame?: boolean, framingType?: FramingType, isReceived?: boolean, serialType?: ProductSerialType, locationTypes?: Array<InventoryLocationType>, categoryIds?: Array<string>, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsGet(sortProductOn, sortDirection, searchTerm, teamId, hasStock, athleteId, shippingOfficeId, hasListings, isLinkedToFrame, framingType, isReceived, serialType, locationTypes, categoryIds, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a product by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [baseUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsMedia360ZipGet(baseUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsMedia360ZipGet(baseUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsMedia360ZipGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a product
         * @param {CreateNewProductRequest} createNewProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsPost(createNewProductRequest: CreateNewProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsPost(createNewProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {ProductAiDescriptionRequest} productAiDescriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdAiDescriptionPost(productId: string, productAiDescriptionRequest: ProductAiDescriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdAiDescriptionPost(productId, productAiDescriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdAiDescriptionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates product inventory location.
         * @param {string} productId 
         * @param {UpdateInventoryLocationRequest} updateInventoryLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdInventoryLocationPut(productId: string, updateInventoryLocationRequest: UpdateInventoryLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdInventoryLocationPut(productId, updateInventoryLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdInventoryLocationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] links a framed product to a frame If the guid is empty it removes the existing link
         * @param {string} productId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdLinkFramedProductPatch(productId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdLinkFramedProductPatch(productId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdLinkFramedProductPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Gets all linked frames to a product
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdLinkedFramesGet(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminLinkedFrame>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdLinkedFramesGet(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdLinkedFramesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Replace a products media-content
         * @param {string} productId The id of the product
         * @param {Array<AdminMediaContentRequest>} adminMediaContentRequest A Cancellation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdMediaContentPatch(productId: string, adminMediaContentRequest: Array<AdminMediaContentRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdMediaContentPatch(productId, adminMediaContentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdMediaContentPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {UpdateProductMediaUrlsRequest} updateProductMediaUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdMediaContentUrlsPut(productId: string, updateProductMediaUrlsRequest: UpdateProductMediaUrlsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdMediaContentUrlsPut(productId, updateProductMediaUrlsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdMediaContentUrlsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {SwitchProductMediaRequest} switchProductMediaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdMediaSwitchPost(productId: string, switchProductMediaRequest: SwitchProductMediaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdMediaSwitchPost(productId, switchProductMediaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdMediaSwitchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create (or update) this product\'s stock lot in Odoo
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdOdooPost(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdOdooPost(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdOdooPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates some parts of the product
         * @param {string} productId 
         * @param {UpdateNewProductRequest} updateNewProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdPatch(productId: string, updateNewProductRequest: UpdateNewProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdPatch(productId, updateNewProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {TranslateProductTextsRequest} translateProductTextsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsProductIdTranslationsPost(productId: string, translateProductTextsRequest: TranslateProductTextsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsProductIdTranslationsPost(productId, translateProductTextsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsProductIdTranslationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Gets scan data for a barcode scan
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsSerialScandataGet(serial: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScanData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsSerialScandataGet(serial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.v2AdminProductsSerialScandataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductsApi - factory interface
 */
export const AdminProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminProductsApiV2AdminProductsAiDescriptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsAiDescriptionsPost(requestParameters: AdminProductsApiV2AdminProductsAiDescriptionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsAiDescriptionsPost(requestParameters.generateAiProductsDescriptionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminProductsApiV2AdminProductsBulkUploadMediaContentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsBulkUploadMediaContentsPut(requestParameters: AdminProductsApiV2AdminProductsBulkUploadMediaContentsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsBulkUploadMediaContentsPut(requestParameters.bulkUpdateProductMediaUrlsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paginated list endpoint for showing and filtering of all products
         * @param {AdminProductsApiV2AdminProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsGet(requestParameters: AdminProductsApiV2AdminProductsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductList> {
            return localVarFp.v2AdminProductsGet(requestParameters.sortProductOn, requestParameters.sortDirection, requestParameters.searchTerm, requestParameters.teamId, requestParameters.hasStock, requestParameters.athleteId, requestParameters.shippingOfficeId, requestParameters.hasListings, requestParameters.isLinkedToFrame, requestParameters.framingType, requestParameters.isReceived, requestParameters.serialType, requestParameters.locationTypes, requestParameters.categoryIds, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a product by id
         * @param {AdminProductsApiV2AdminProductsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsIdGet(requestParameters: AdminProductsApiV2AdminProductsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductDetails> {
            return localVarFp.v2AdminProductsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminProductsApiV2AdminProductsMedia360ZipGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsMedia360ZipGet(requestParameters: AdminProductsApiV2AdminProductsMedia360ZipGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v2AdminProductsMedia360ZipGet(requestParameters.baseUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a product
         * @param {AdminProductsApiV2AdminProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsPost(requestParameters: AdminProductsApiV2AdminProductsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v2AdminProductsPost(requestParameters.createNewProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminProductsApiV2AdminProductsProductIdAiDescriptionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdAiDescriptionPost(requestParameters: AdminProductsApiV2AdminProductsProductIdAiDescriptionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsProductIdAiDescriptionPost(requestParameters.productId, requestParameters.productAiDescriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates product inventory location.
         * @param {AdminProductsApiV2AdminProductsProductIdInventoryLocationPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdInventoryLocationPut(requestParameters: AdminProductsApiV2AdminProductsProductIdInventoryLocationPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductDetails> {
            return localVarFp.v2AdminProductsProductIdInventoryLocationPut(requestParameters.productId, requestParameters.updateInventoryLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] links a framed product to a frame If the guid is empty it removes the existing link
         * @param {AdminProductsApiV2AdminProductsProductIdLinkFramedProductPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdLinkFramedProductPatch(requestParameters: AdminProductsApiV2AdminProductsProductIdLinkFramedProductPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsProductIdLinkFramedProductPatch(requestParameters.productId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Gets all linked frames to a product
         * @param {AdminProductsApiV2AdminProductsProductIdLinkedFramesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdLinkedFramesGet(requestParameters: AdminProductsApiV2AdminProductsProductIdLinkedFramesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminLinkedFrame>> {
            return localVarFp.v2AdminProductsProductIdLinkedFramesGet(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Replace a products media-content
         * @param {AdminProductsApiV2AdminProductsProductIdMediaContentPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdMediaContentPatch(requestParameters: AdminProductsApiV2AdminProductsProductIdMediaContentPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsProductIdMediaContentPatch(requestParameters.productId, requestParameters.adminMediaContentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminProductsApiV2AdminProductsProductIdMediaContentUrlsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdMediaContentUrlsPut(requestParameters: AdminProductsApiV2AdminProductsProductIdMediaContentUrlsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsProductIdMediaContentUrlsPut(requestParameters.productId, requestParameters.updateProductMediaUrlsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminProductsApiV2AdminProductsProductIdMediaSwitchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdMediaSwitchPost(requestParameters: AdminProductsApiV2AdminProductsProductIdMediaSwitchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsProductIdMediaSwitchPost(requestParameters.productId, requestParameters.switchProductMediaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create (or update) this product\'s stock lot in Odoo
         * @param {AdminProductsApiV2AdminProductsProductIdOdooPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdOdooPost(requestParameters: AdminProductsApiV2AdminProductsProductIdOdooPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsProductIdOdooPost(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates some parts of the product
         * @param {AdminProductsApiV2AdminProductsProductIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdPatch(requestParameters: AdminProductsApiV2AdminProductsProductIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsProductIdPatch(requestParameters.productId, requestParameters.updateNewProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminProductsApiV2AdminProductsProductIdTranslationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsProductIdTranslationsPost(requestParameters: AdminProductsApiV2AdminProductsProductIdTranslationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminProductsProductIdTranslationsPost(requestParameters.productId, requestParameters.translateProductTextsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Gets scan data for a barcode scan
         * @param {AdminProductsApiV2AdminProductsSerialScandataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsSerialScandataGet(requestParameters: AdminProductsApiV2AdminProductsSerialScandataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScanData> {
            return localVarFp.v2AdminProductsSerialScandataGet(requestParameters.serial, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminProductsAiDescriptionsPost operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsAiDescriptionsPostRequest {
    readonly generateAiProductsDescriptionsRequest: GenerateAiProductsDescriptionsRequest
}

/**
 * Request parameters for v2AdminProductsBulkUploadMediaContentsPut operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsBulkUploadMediaContentsPutRequest {
    readonly bulkUpdateProductMediaUrlsRequest: BulkUpdateProductMediaUrlsRequest
}

/**
 * Request parameters for v2AdminProductsGet operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsGetRequest {
    readonly sortProductOn?: SortProductOn

    readonly sortDirection?: SortDirection

    readonly searchTerm?: string

    readonly teamId?: string

    readonly hasStock?: boolean

    readonly athleteId?: string

    readonly shippingOfficeId?: string

    readonly hasListings?: boolean

    readonly isLinkedToFrame?: boolean

    readonly framingType?: FramingType

    readonly isReceived?: boolean

    readonly serialType?: ProductSerialType

    readonly locationTypes?: Array<InventoryLocationType>

    readonly categoryIds?: Array<string>

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for v2AdminProductsIdGet operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for v2AdminProductsMedia360ZipGet operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsMedia360ZipGetRequest {
    readonly baseUrl?: string
}

/**
 * Request parameters for v2AdminProductsPost operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsPostRequest {
    readonly createNewProductRequest: CreateNewProductRequest
}

/**
 * Request parameters for v2AdminProductsProductIdAiDescriptionPost operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdAiDescriptionPostRequest {
    readonly productId: string

    readonly productAiDescriptionRequest: ProductAiDescriptionRequest
}

/**
 * Request parameters for v2AdminProductsProductIdInventoryLocationPut operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdInventoryLocationPutRequest {
    /**
     * 
     */
    readonly productId: string

    /**
     * 
     */
    readonly updateInventoryLocationRequest: UpdateInventoryLocationRequest
}

/**
 * Request parameters for v2AdminProductsProductIdLinkFramedProductPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdLinkFramedProductPatchRequest {
    readonly productId: string

    readonly body: string
}

/**
 * Request parameters for v2AdminProductsProductIdLinkedFramesGet operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdLinkedFramesGetRequest {
    readonly productId: string
}

/**
 * Request parameters for v2AdminProductsProductIdMediaContentPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdMediaContentPatchRequest {
    /**
     * The id of the product
     */
    readonly productId: string

    /**
     * A Cancellation token.
     */
    readonly adminMediaContentRequest: Array<AdminMediaContentRequest>
}

/**
 * Request parameters for v2AdminProductsProductIdMediaContentUrlsPut operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdMediaContentUrlsPutRequest {
    readonly productId: string

    readonly updateProductMediaUrlsRequest: UpdateProductMediaUrlsRequest
}

/**
 * Request parameters for v2AdminProductsProductIdMediaSwitchPost operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdMediaSwitchPostRequest {
    readonly productId: string

    readonly switchProductMediaRequest: SwitchProductMediaRequest
}

/**
 * Request parameters for v2AdminProductsProductIdOdooPost operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdOdooPostRequest {
    readonly productId: string
}

/**
 * Request parameters for v2AdminProductsProductIdPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdPatchRequest {
    /**
     * 
     */
    readonly productId: string

    /**
     * 
     */
    readonly updateNewProductRequest: UpdateNewProductRequest
}

/**
 * Request parameters for v2AdminProductsProductIdTranslationsPost operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsProductIdTranslationsPostRequest {
    readonly productId: string

    readonly translateProductTextsRequest: TranslateProductTextsRequest
}

/**
 * Request parameters for v2AdminProductsSerialScandataGet operation in AdminProductsApi.
 */
export interface AdminProductsApiV2AdminProductsSerialScandataGetRequest {
    readonly serial: string
}

/**
 * AdminProductsApi - object-oriented interface
 */
export class AdminProductsApi extends BaseAPI {
    /**
     * 
     * @param {AdminProductsApiV2AdminProductsAiDescriptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsAiDescriptionsPost(requestParameters: AdminProductsApiV2AdminProductsAiDescriptionsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsAiDescriptionsPost(requestParameters.generateAiProductsDescriptionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminProductsApiV2AdminProductsBulkUploadMediaContentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsBulkUploadMediaContentsPut(requestParameters: AdminProductsApiV2AdminProductsBulkUploadMediaContentsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsBulkUploadMediaContentsPut(requestParameters.bulkUpdateProductMediaUrlsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paginated list endpoint for showing and filtering of all products
     * @param {AdminProductsApiV2AdminProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsGet(requestParameters: AdminProductsApiV2AdminProductsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsGet(requestParameters.sortProductOn, requestParameters.sortDirection, requestParameters.searchTerm, requestParameters.teamId, requestParameters.hasStock, requestParameters.athleteId, requestParameters.shippingOfficeId, requestParameters.hasListings, requestParameters.isLinkedToFrame, requestParameters.framingType, requestParameters.isReceived, requestParameters.serialType, requestParameters.locationTypes, requestParameters.categoryIds, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a product by id
     * @param {AdminProductsApiV2AdminProductsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsIdGet(requestParameters: AdminProductsApiV2AdminProductsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminProductsApiV2AdminProductsMedia360ZipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsMedia360ZipGet(requestParameters: AdminProductsApiV2AdminProductsMedia360ZipGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsMedia360ZipGet(requestParameters.baseUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a product
     * @param {AdminProductsApiV2AdminProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsPost(requestParameters: AdminProductsApiV2AdminProductsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsPost(requestParameters.createNewProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminProductsApiV2AdminProductsProductIdAiDescriptionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdAiDescriptionPost(requestParameters: AdminProductsApiV2AdminProductsProductIdAiDescriptionPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdAiDescriptionPost(requestParameters.productId, requestParameters.productAiDescriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates product inventory location.
     * @param {AdminProductsApiV2AdminProductsProductIdInventoryLocationPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdInventoryLocationPut(requestParameters: AdminProductsApiV2AdminProductsProductIdInventoryLocationPutRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdInventoryLocationPut(requestParameters.productId, requestParameters.updateInventoryLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] links a framed product to a frame If the guid is empty it removes the existing link
     * @param {AdminProductsApiV2AdminProductsProductIdLinkFramedProductPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdLinkFramedProductPatch(requestParameters: AdminProductsApiV2AdminProductsProductIdLinkFramedProductPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdLinkFramedProductPatch(requestParameters.productId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Gets all linked frames to a product
     * @param {AdminProductsApiV2AdminProductsProductIdLinkedFramesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdLinkedFramesGet(requestParameters: AdminProductsApiV2AdminProductsProductIdLinkedFramesGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdLinkedFramesGet(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Replace a products media-content
     * @param {AdminProductsApiV2AdminProductsProductIdMediaContentPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdMediaContentPatch(requestParameters: AdminProductsApiV2AdminProductsProductIdMediaContentPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdMediaContentPatch(requestParameters.productId, requestParameters.adminMediaContentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminProductsApiV2AdminProductsProductIdMediaContentUrlsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdMediaContentUrlsPut(requestParameters: AdminProductsApiV2AdminProductsProductIdMediaContentUrlsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdMediaContentUrlsPut(requestParameters.productId, requestParameters.updateProductMediaUrlsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminProductsApiV2AdminProductsProductIdMediaSwitchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdMediaSwitchPost(requestParameters: AdminProductsApiV2AdminProductsProductIdMediaSwitchPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdMediaSwitchPost(requestParameters.productId, requestParameters.switchProductMediaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create (or update) this product\'s stock lot in Odoo
     * @param {AdminProductsApiV2AdminProductsProductIdOdooPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdOdooPost(requestParameters: AdminProductsApiV2AdminProductsProductIdOdooPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdOdooPost(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates some parts of the product
     * @param {AdminProductsApiV2AdminProductsProductIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdPatch(requestParameters: AdminProductsApiV2AdminProductsProductIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdPatch(requestParameters.productId, requestParameters.updateNewProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminProductsApiV2AdminProductsProductIdTranslationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsProductIdTranslationsPost(requestParameters: AdminProductsApiV2AdminProductsProductIdTranslationsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsProductIdTranslationsPost(requestParameters.productId, requestParameters.translateProductTextsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Gets scan data for a barcode scan
     * @param {AdminProductsApiV2AdminProductsSerialScandataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsSerialScandataGet(requestParameters: AdminProductsApiV2AdminProductsSerialScandataGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).v2AdminProductsSerialScandataGet(requestParameters.serial, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductsPickListApi - axios parameter creator
 */
export const AdminProductsPickListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get products by location for picklist
         * @param {string} [location] 
         * @param {number | null} [section] 
         * @param {string} [subSection] 
         * @param {boolean} [framed] 
         * @param {string} [shippingOfficeId] 
         * @param {Date} [productListingEndDate] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsPicklistsGet: async (location?: string, section?: number | null, subSection?: string, framed?: boolean, shippingOfficeId?: string, productListingEndDate?: Date, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admin/products/picklists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (subSection !== undefined) {
                localVarQueryParameter['sub_section'] = subSection;
            }

            if (framed !== undefined) {
                localVarQueryParameter['framed'] = framed;
            }

            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shipping_office_id'] = shippingOfficeId;
            }

            if (productListingEndDate !== undefined) {
                localVarQueryParameter['product_listing_end_date'] = (productListingEndDate as any instanceof Date) ?
                    (productListingEndDate as any).toISOString() :
                    productListingEndDate;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductsPickListApi - functional programming interface
 */
export const AdminProductsPickListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductsPickListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get products by location for picklist
         * @param {string} [location] 
         * @param {number | null} [section] 
         * @param {string} [subSection] 
         * @param {boolean} [framed] 
         * @param {string} [shippingOfficeId] 
         * @param {Date} [productListingEndDate] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminProductsPicklistsGet(location?: string, section?: number | null, subSection?: string, framed?: boolean, shippingOfficeId?: string, productListingEndDate?: Date, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPickListItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminProductsPicklistsGet(location, section, subSection, framed, shippingOfficeId, productListingEndDate, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsPickListApi.v2AdminProductsPicklistsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductsPickListApi - factory interface
 */
export const AdminProductsPickListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductsPickListApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get products by location for picklist
         * @param {AdminProductsPickListApiV2AdminProductsPicklistsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminProductsPicklistsGet(requestParameters: AdminProductsPickListApiV2AdminProductsPicklistsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductPickListItemList> {
            return localVarFp.v2AdminProductsPicklistsGet(requestParameters.location, requestParameters.section, requestParameters.subSection, requestParameters.framed, requestParameters.shippingOfficeId, requestParameters.productListingEndDate, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminProductsPicklistsGet operation in AdminProductsPickListApi.
 */
export interface AdminProductsPickListApiV2AdminProductsPicklistsGetRequest {
    /**
     * 
     */
    readonly location?: string

    /**
     * 
     */
    readonly section?: number | null

    /**
     * 
     */
    readonly subSection?: string

    /**
     * 
     */
    readonly framed?: boolean

    readonly shippingOfficeId?: string

    readonly productListingEndDate?: Date

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * AdminProductsPickListApi - object-oriented interface
 */
export class AdminProductsPickListApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get products by location for picklist
     * @param {AdminProductsPickListApiV2AdminProductsPicklistsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminProductsPicklistsGet(requestParameters: AdminProductsPickListApiV2AdminProductsPicklistsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductsPickListApiFp(this.configuration).v2AdminProductsPicklistsGet(requestParameters.location, requestParameters.section, requestParameters.subSection, requestParameters.framed, requestParameters.shippingOfficeId, requestParameters.productListingEndDate, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminTranslationsApi - axios parameter creator
 */
export const AdminTranslationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} entityId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdKeyGet: async (entityId: string, key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyGet', 'entityId', entityId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyGet', 'key', key)
            const localVarPath = `/v2/admin/translations/entity/{entityId}/{key}`
                .replace('{entityId}', encodeURIComponent(String(entityId)))
                .replace('{key}', encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityId 
         * @param {string} key 
         * @param {string} entity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdKeyGet_1: async (entityId: string, key: string, entity: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyGet_1', 'entityId', entityId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyGet_1', 'key', key)
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyGet_1', 'entity', entity)
            const localVarPath = `/v2/admin/translations/{entity}/{entityId}/{key}`
                .replace('{entityId}', encodeURIComponent(String(entityId)))
                .replace('{key}', encodeURIComponent(String(key)))
                .replace('{entity}', encodeURIComponent(String(entity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TranslationEntityType} entity 
         * @param {string} entityId 
         * @param {string} key 
         * @param {string} language 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdKeyLanguagePut: async (entity: TranslationEntityType, entityId: string, key: string, language: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyLanguagePut', 'entity', entity)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyLanguagePut', 'entityId', entityId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyLanguagePut', 'key', key)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyLanguagePut', 'language', language)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdKeyLanguagePut', 'body', body)
            const localVarPath = `/v2/admin/translations/{entity}/{entityId}/{key}/{language}`
                .replace('{entity}', encodeURIComponent(String(entity)))
                .replace('{entityId}', encodeURIComponent(String(entityId)))
                .replace('{key}', encodeURIComponent(String(key)))
                .replace('{language}', encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = body

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityId 
         * @param {UpdateTranslationRequest} updateTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdPut: async (entityId: string, updateTranslationRequest: UpdateTranslationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdPut', 'entityId', entityId)
            // verify required parameter 'updateTranslationRequest' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdPut', 'updateTranslationRequest', updateTranslationRequest)
            const localVarPath = `/v2/admin/translations/entity/{entityId}`
                .replace('{entityId}', encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateTranslationRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TranslationEntityType} entity 
         * @param {string} entityId 
         * @param {UpdateTranslationRequest} updateTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdPut_2: async (entity: TranslationEntityType, entityId: string, updateTranslationRequest: UpdateTranslationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdPut_2', 'entity', entity)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdPut_2', 'entityId', entityId)
            // verify required parameter 'updateTranslationRequest' is not null or undefined
            assertParamExists('v2AdminTranslationsEntityEntityIdPut_2', 'updateTranslationRequest', updateTranslationRequest)
            const localVarPath = `/v2/admin/translations/{entity}/{entityId}`
                .replace('{entity}', encodeURIComponent(String(entity)))
                .replace('{entityId}', encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateTranslationRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminTranslationsApi - functional programming interface
 */
export const AdminTranslationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminTranslationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} entityId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminTranslationsEntityEntityIdKeyGet(entityId: string, key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Translations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminTranslationsEntityEntityIdKeyGet(entityId, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTranslationsApi.v2AdminTranslationsEntityEntityIdKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} entityId 
         * @param {string} key 
         * @param {string} entity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminTranslationsEntityEntityIdKeyGet_1(entityId: string, key: string, entity: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Translations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminTranslationsEntityEntityIdKeyGet_1(entityId, key, entity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTranslationsApi.v2AdminTranslationsEntityEntityIdKeyGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TranslationEntityType} entity 
         * @param {string} entityId 
         * @param {string} key 
         * @param {string} language 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminTranslationsEntityEntityIdKeyLanguagePut(entity: TranslationEntityType, entityId: string, key: string, language: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminTranslationsEntityEntityIdKeyLanguagePut(entity, entityId, key, language, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTranslationsApi.v2AdminTranslationsEntityEntityIdKeyLanguagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} entityId 
         * @param {UpdateTranslationRequest} updateTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminTranslationsEntityEntityIdPut(entityId: string, updateTranslationRequest: UpdateTranslationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminTranslationsEntityEntityIdPut(entityId, updateTranslationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTranslationsApi.v2AdminTranslationsEntityEntityIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TranslationEntityType} entity 
         * @param {string} entityId 
         * @param {UpdateTranslationRequest} updateTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2AdminTranslationsEntityEntityIdPut_2(entity: TranslationEntityType, entityId: string, updateTranslationRequest: UpdateTranslationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2AdminTranslationsEntityEntityIdPut_2(entity, entityId, updateTranslationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTranslationsApi.v2AdminTranslationsEntityEntityIdPut_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminTranslationsApi - factory interface
 */
export const AdminTranslationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminTranslationsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdKeyGet(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Translations> {
            return localVarFp.v2AdminTranslationsEntityEntityIdKeyGet(requestParameters.entityId, requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGet0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdKeyGet_1(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGet0Request, options?: RawAxiosRequestConfig): AxiosPromise<Translations> {
            return localVarFp.v2AdminTranslationsEntityEntityIdKeyGet_1(requestParameters.entityId, requestParameters.key, requestParameters.entity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyLanguagePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdKeyLanguagePut(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyLanguagePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminTranslationsEntityEntityIdKeyLanguagePut(requestParameters.entity, requestParameters.entityId, requestParameters.key, requestParameters.language, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdPut(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminTranslationsEntityEntityIdPut(requestParameters.entityId, requestParameters.updateTranslationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdPut0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdminTranslationsEntityEntityIdPut_2(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdPut0Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2AdminTranslationsEntityEntityIdPut_2(requestParameters.entity, requestParameters.entityId, requestParameters.updateTranslationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v2AdminTranslationsEntityEntityIdKeyGet operation in AdminTranslationsApi.
 */
export interface AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGetRequest {
    readonly entityId: string

    readonly key: string
}

/**
 * Request parameters for v2AdminTranslationsEntityEntityIdKeyGet_1 operation in AdminTranslationsApi.
 */
export interface AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGet0Request {
    readonly entityId: string

    readonly key: string

    readonly entity: string
}

/**
 * Request parameters for v2AdminTranslationsEntityEntityIdKeyLanguagePut operation in AdminTranslationsApi.
 */
export interface AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyLanguagePutRequest {
    readonly entity: TranslationEntityType

    readonly entityId: string

    readonly key: string

    readonly language: string

    readonly body: string
}

/**
 * Request parameters for v2AdminTranslationsEntityEntityIdPut operation in AdminTranslationsApi.
 */
export interface AdminTranslationsApiV2AdminTranslationsEntityEntityIdPutRequest {
    readonly entityId: string

    readonly updateTranslationRequest: UpdateTranslationRequest
}

/**
 * Request parameters for v2AdminTranslationsEntityEntityIdPut_2 operation in AdminTranslationsApi.
 */
export interface AdminTranslationsApiV2AdminTranslationsEntityEntityIdPut0Request {
    readonly entity: TranslationEntityType

    readonly entityId: string

    readonly updateTranslationRequest: UpdateTranslationRequest
}

/**
 * AdminTranslationsApi - object-oriented interface
 */
export class AdminTranslationsApi extends BaseAPI {
    /**
     * 
     * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminTranslationsEntityEntityIdKeyGet(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGetRequest, options?: RawAxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).v2AdminTranslationsEntityEntityIdKeyGet(requestParameters.entityId, requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGet0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminTranslationsEntityEntityIdKeyGet_1(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyGet0Request, options?: RawAxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).v2AdminTranslationsEntityEntityIdKeyGet_1(requestParameters.entityId, requestParameters.key, requestParameters.entity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyLanguagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminTranslationsEntityEntityIdKeyLanguagePut(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdKeyLanguagePutRequest, options?: RawAxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).v2AdminTranslationsEntityEntityIdKeyLanguagePut(requestParameters.entity, requestParameters.entityId, requestParameters.key, requestParameters.language, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminTranslationsEntityEntityIdPut(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).v2AdminTranslationsEntityEntityIdPut(requestParameters.entityId, requestParameters.updateTranslationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminTranslationsApiV2AdminTranslationsEntityEntityIdPut0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public v2AdminTranslationsEntityEntityIdPut_2(requestParameters: AdminTranslationsApiV2AdminTranslationsEntityEntityIdPut0Request, options?: RawAxiosRequestConfig) {
        return AdminTranslationsApiFp(this.configuration).v2AdminTranslationsEntityEntityIdPut_2(requestParameters.entity, requestParameters.entityId, requestParameters.updateTranslationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



